import { visualizationMode } from '../../../../redux/visualizationModeSlice';
import { useSelector } from 'react-redux';

type DrawerProps = {
	children: React.ReactNode;
	isOpen: boolean;
};

const Drawer = ({ children, isOpen }: DrawerProps) => {
	const VMMode = useSelector(visualizationMode);
	// const renderStyles = () => {
	//     if (isOpen) {
	//         return {
	//             maxWidth: "400px",
	//             minWidth: "280px",
	//             width: "100vw",
	//             height: "100vh",
	//             maxHeight: "700px",
	//             position: "absolute" as "absolute",
	//             transition: "0.3s",
	//             left: "calc(100% - 400px)",
	//         };
	//     }

	//     return {
	//         maxWidth: "400px",
	//         minWidth: "280px",
	//         width: "100vw",
	//         height: "100vh",
	//         maxHeight: "700px",
	//         position: "absolute" as "absolute",
	//         transition: "0.3s",
	//         left: "100%",
	//     };
	// };

	const renderStyles = () => {
		if (isOpen) {
			return {
				width: '85%',
				maxWidth: '400px',
				minWidth: '280px',
				transform: 'translate3d(0%, 0px, 0px)',
				top: VMMode ? 0 : '72px',
				transition: '0.3s',
			};
		}

		return {
			width: '85%',
			maxWidth: '400px',
			minWidth: '280px',
			transform: 'translate3d(100%, 0px, 0px)',
			top: VMMode ? 0 : '72px',
			transition: '0.3s',
		};
	};

	//DraggableBox fix for highlight
	return (
		<div
			aria-hidden="true"
			className={`DraggableBox drawer vtex-minicart-2-x-drawer vtex-minicart-2-x-closed  right-0 fixed top-0 bottom-0 bg-base z-999 flex flex-column`}
			style={renderStyles()}
		>
			{children}
		</div>
	);
};

export default Drawer;
